import { useChangeLocale, useRouter } from '@application/utils';
import { isProduction } from '@application/env';
import type { LanguageSelectorButton } from '@presentation/components';
import { i18n } from '@application/i18n';
import { useMemo } from 'react';
import { CountryCode } from '@gql/graphql';

const isProd = isProduction();

export const useLanguageSelectorButtons = () => {
  const { countryCode, language } = useRouter();
  const { changeLocale } = useChangeLocale();

  const languageSelectorButtons: LanguageSelectorButton[] = useMemo(() => {
    switch (countryCode) {
      case CountryCode.BE:
        return [
          {
            label: 'FR',
            onClick: () => {
              changeLocale('fr', undefined, true);
            },
            selected: language === 'fr',
            onDoubleClick: () => {
              if (isProd) {
                return;
              }

              i18n.changeLanguage('cimode');
            },
          },
          {
            label: 'NL',
            onClick: () => {
              changeLocale('nl', undefined, true);
            },
            selected: language === 'nl',
            onDoubleClick: () => {
              if (isProd) {
                return;
              }

              i18n.changeLanguage('cimode');
            },
          },
        ];
      case CountryCode.CH:
        return [
          {
            label: 'FR',
            onClick: () => {
              changeLocale('fr', undefined, true);
            },
            selected: language === 'fr',
            onDoubleClick: () => {
              if (isProd) {
                return;
              }

              i18n.changeLanguage('cimode');
            },
          },
          {
            label: 'DE',
            onClick: () => {
              changeLocale('de', undefined, true);
            },
            selected: language === 'de',
            onDoubleClick: () => {
              if (isProd) {
                return;
              }

              i18n.changeLanguage('cimode');
            },
          },
        ];
      default:
        return [];
    }
  }, [changeLocale, countryCode, language]);

  return { languageSelectorButtons };
};
